import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Box,
  Container,
  Divider,
  Grid,
  Typography,
  makeStyles,
  colors,
  Card,
  CardContent,
  CardActionArea,
} from '@material-ui/core';

import { Link as RouterLink } from 'react-router-dom';


const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#e0ecf8',
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(6),
    '& dt': {
      marginTop: theme.spacing(2)
    }
  },
  icon: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    height: 70,
    width: 70
  },
  avatar: {
    backgroundColor: colors.red[600]
  },
  stepper: {
    backgroundColor: 'transparent'
  },
  name: {
    marginTop: theme.spacing(1)
  }
}));

const FAQs = ({ className, ...rest }) => {
  const classes = useStyles();


  return (
    <div
      className={clsx(classes.root, className)}
      {...rest}
    >
      <div id="api-catalogue">

        <Container maxWidth="lg">

    
        
          <Box mt={8}>
            <Grid
              container
              spacing={3}
            >
      
              <Grid
                item
                xs={12}
                md={12}
              >
                <Card>
                  <CardActionArea
                    component={RouterLink}
                    to={{ pathname: "/tools/free-qrcode-generator/free-qrcode-for-website-url" }}
                     >
                    <CardContent>
                      <Box
                        display="flex"
                        flexDirection="column"
                        textAlign="left"
                      >
              
                        <Typography
                          variant="h2"
                          gutterBottom
                          color="textPrimary"
                        > How do I create a QR code for the URL?
                        </Typography>


                        <Typography
                          variant="body1"
                          gutterBottom
                          color="textPrimary"
                        >
                          With our barcode generator API, you can create and print barcodes of any size with ease. Our intuitive API allows you to customize your barcodes and add features like text, images, colors, and shapes. Create the perfect barcode for your Business!!                            </Typography>

                      </Box>
                    </CardContent>

                  </CardActionArea>
                </Card>

              </Grid>


              <Grid
                item
                xs={12}
                md={12}
              >
                <Card>
                  <CardActionArea
                    component={RouterLink}
                    to={{ pathname: "/tools/free-qrcode-generator/free-qrcode-for-plain-text" }}
                    >
                    <CardContent>
                      <Box
                        display="flex"
                        flexDirection="column"
                        textAlign="left"
                      >
              
                        <Typography
                          variant="h2"
                          gutterBottom
                          color="textPrimary"
                        > How do I create a Free QR code for Plain Text?
                        </Typography>


                        <Typography
                          variant="body1"
                          gutterBottom
                          color="textPrimary"
                        >
QR codes are becoming increasingly popular as a marketing tool. They provide an effective way to promote products or services, as well as increase customer engagement. Creating a custom QR code is easy and free with the right tools. With these tools, you can quickly generate a QR code for plain text that can be used for marketing purposes.                          
                          
                           </Typography>

                      </Box>
                    </CardContent>

                  </CardActionArea>
                </Card>

              </Grid>

              <Grid
                item
                xs={12}
                md={12}
              >
                <Card>
                  <CardActionArea
                    component={RouterLink}
                    to={{ pathname: "/tools/free-qrcode-generator/free-qrcode-for-email-message" }}
                     >
                    <CardContent>
                      <Box
                        display="flex"
                        flexDirection="column"
                        textAlign="left"
                      >
              
                        <Typography
                          variant="h2"
                          gutterBottom
                          color="textPrimary"
                        > How do I create a QR code for Email?
                        </Typography>


                        <Typography
                          variant="body1"
                          gutterBottom
                          color="textPrimary"
                        >
QR codes are an increasingly popular way to quickly and easily share contact information, websites, and other data. APITier’s free tool can generate a unique QR code for any email address in just a few clicks, saving time and energy for copywriters who need to create multiple QR codes with different emails.                          
                           </Typography>

                      </Box>
                    </CardContent>

                  </CardActionArea>
                </Card>

              </Grid>

              <Grid
                item
                xs={12}
                md={12}
              >
                <Card>
                  <CardActionArea
                    component={RouterLink}
                    to={{ pathname: "/tools/free-qrcode-generator/free-qrcode-for-sms-message" }}
                     >
                    <CardContent>
                      <Box
                        display="flex"
                        flexDirection="column"
                        textAlign="left"
                      >
              
                        <Typography
                          variant="h2"
                          gutterBottom
                          color="textPrimary"
                        > How do I create a QR code for SMS?
                        </Typography>


                        <Typography
                          variant="body1"
                          gutterBottom
                          color="textPrimary"
                        >
QR codes are a powerful tool for businesses to quickly and easily send text messages or other forms of content to customers. With a free QR code generator, businesses can create custom codes that contain SMS messages, links to websites, and more -- all at no cost. This allows companies to easily promote their products and services with minimal effort.                          
                           </Typography>

                      </Box>
                    </CardContent>

                  </CardActionArea>
                </Card>

              </Grid>

              <Grid
                item
                xs={12}
                md={12}
              >
                <Card>
                  <CardActionArea
                    component={RouterLink}
                    to={{ pathname: "/tools/free-qrcode-generator/free-qrcode-for-calling" }}
                     >
                    <CardContent>
                      <Box
                        display="flex"
                        flexDirection="column"
                        textAlign="left"
                      >
              
                        <Typography
                          variant="h2"
                          gutterBottom
                          color="textPrimary"
                        > How do I generate a QR code for Phone?
                        </Typography>


                        <Typography
                          variant="body1"
                          gutterBottom
                          color="textPrimary"
                        >
QR codes are quickly becoming an essential tool for businesses looking to streamline communications with customers. With a free QR code generator, you can easily create a code that links to any phone number, allowing customers to call your business with the simple scan of a QR code. These codes can be added to websites, print materials, and even social media posts, making it easier than ever for customers to get in touch with your business.                          
                           </Typography>

                      </Box>
                    </CardContent>

                  </CardActionArea>
                </Card>

              </Grid>

              <Grid
                item
                xs={12}
                md={12}
              >
                <Card>
                  <CardActionArea
                    component={RouterLink}
                    to={{ pathname: "/tools/free-qrcode-generator/free-qrcode-for-whatsapp-message" }}
                     >
                    <CardContent>
                      <Box
                        display="flex"
                        flexDirection="column"
                        textAlign="left"
                      >
              
                        <Typography
                          variant="h2"
                          gutterBottom
                          color="textPrimary"
                        > How do I generate a QR code for WhatsApp?
                        </Typography>


                        <Typography
                          variant="body1"
                          gutterBottom
                          color="textPrimary"
                        >
QR codes are one of the most convenient ways to connect with people quickly and easily. With a free QR code generator for WhatsApp Calling, you can now generate your own QR codes in just a few clicks. These codes can be used to instantly call people on WhatsApp, eliminating the need to manually search and add contacts. This is an incredibly helpful tool for businesses looking to reach out to their customers quickly and cost-effectively.                          
                           </Typography>

                      </Box>
                    </CardContent>

                  </CardActionArea>
                </Card>

              </Grid>

              <Grid
                item
                xs={12}
                md={12}
              >
                <Card>
                  <CardActionArea
                    component={RouterLink}
                    to={{ pathname: "/tools/free-qrcode-generator/free-qrcode-for-skype-call" }}
                     >
                    <CardContent>
                      <Box
                        display="flex"
                        flexDirection="column"
                        textAlign="left"
                      >
              
                        <Typography
                          variant="h2"
                          gutterBottom
                          color="textPrimary"
                        > How do I generate a QR code for Skype calling?
                        </Typography>


                        <Typography
                          variant="body1"
                          gutterBottom
                          color="textPrimary"
                        >
With the advancements in technology, generating a QR code for Skype calling has never been easier. There are now numerous free QR code generators available online which allow users to quickly and easily generate their own QR codes for Skype calls. These free QR code generators provide an easy way to connect with others, allowing users to take advantage of the convenience and flexibility of Skype calling.                          
                           </Typography>

                      </Box>
                    </CardContent>

                  </CardActionArea>
                </Card>

              </Grid>

              <Grid
                item
                xs={12}
                md={12}
              >
                <Card>
                  <CardActionArea
                    component={RouterLink}
                    to={{ pathname: "/tools/free-qrcode-generator/free-qrcode-for-youtube-video" }}
                     >
                    <CardContent>
                      <Box
                        display="flex"
                        flexDirection="column"
                        textAlign="left"
                      >
              
                        <Typography
                          variant="h2"
                          gutterBottom
                          color="textPrimary"
                        > How do I generate a QR code to share YouTube Video?
                        </Typography>


                        <Typography
                          variant="body1"
                          gutterBottom
                          color="textPrimary"
                        >
QR codes are an effective way to quickly and easily share YouTube videos. With a free QR code generator, anyone can generate custom QR codes that direct users to any YouTube video in a matter of seconds. This is an invaluable tool for marketers, businesses, and individuals who want to quickly share their content with the world.                          
                           </Typography>

                      </Box>
                    </CardContent>

                  </CardActionArea>
                </Card>

              </Grid>

              <Grid
                item
                xs={12}
                md={12}
              >
                <Card>
                  <CardActionArea
                    component={RouterLink}
                    to={{ pathname: "/tools/free-qrcode-generator/free-qrcode-for-tweets" }}
                     >
                    <CardContent>
                      <Box
                        display="flex"
                        flexDirection="column"
                        textAlign="left"
                      >
              
                        <Typography
                          variant="h2"
                          gutterBottom
                          color="textPrimary"
                        > How do I generate a QR code for Twitter?
                        </Typography>


                        <Typography
                          variant="body1"
                          gutterBottom
                          color="textPrimary"
                        >
Sharing tweets via QR codes has never been easier with free QR code generators. These generators allow you to generate unique codes that can be scanned to instantly take users to a tweet. This is a great way for businesses, influencers, and anyone else who wants to share their content on the go without the hassle of manually typing out a link.                          
                           </Typography>

                      </Box>
                    </CardContent>

                  </CardActionArea>
                </Card>

              </Grid>

              <Grid
                item
                xs={12}
                md={12}
              >
                <Card>
                  <CardActionArea
                    component={RouterLink}
                    to={{ pathname: "/tools/free-qrcode-generator/free-qrcode-for-facebook-posts" }}
                     >
                    <CardContent>
                      <Box
                        display="flex"
                        flexDirection="column"
                        textAlign="left"
                      >
              
                        <Typography
                          variant="h2"
                          gutterBottom
                          color="textPrimary"
                        > How do I generate a QR code for Facebook?
                        </Typography>


                        <Typography
                          variant="body1"
                          gutterBottom
                          color="textPrimary"
                        >
QR codes are fast becoming an essential tool for businesses to share information quickly and easily. With the help of a free QR code generator, you can now create your own unique QR codes to share with your customers on Facebook, Twitter, or any other social media platform. Not only do they provide a fast and convenient way to access data but they are also cost-effective and secure.                          
                           </Typography>

                      </Box>
                    </CardContent>

                  </CardActionArea>
                </Card>

              </Grid>

              <Grid
                item
                xs={12}
                md={12}
              >
                <Card>
                  <CardActionArea
                    component={RouterLink}
                    to={{ pathname: "/tools/free-qrcode-generator/free-qrcode-for-instagram" }}
                     >
                    <CardContent>
                      <Box
                        display="flex"
                        flexDirection="column"
                        textAlign="left"
                      >
              
                        <Typography
                          variant="h2"
                          gutterBottom
                          color="textPrimary"
                        > How do I generate a QR code for Instagram?
                        </Typography>


                        <Typography
                          variant="body1"
                          gutterBottom
                          color="textPrimary"
                        >
QR codes are becoming increasingly popular as a way to share information quickly and easily. With a free QR code generator, you can now create your own custom QR code to share on Instagram with just a few clicks. No longer do you have to worry about complicated coding or expensive design software - all you need is an internet connection and the right tool for the job.                          
                           </Typography>

                      </Box>
                    </CardContent>

                  </CardActionArea>
                </Card>

              </Grid>

              <Grid
                item
                xs={12}
                md={12}
              >
                <Card>
                  <CardActionArea
                    component={RouterLink}
                    to={{ pathname: "/tools/free-qrcode-generator/free-qrcode-for-app-store" }}
                     >
                    <CardContent>
                      <Box
                        display="flex"
                        flexDirection="column"
                        textAlign="left"
                      >
              
                        <Typography
                          variant="h2"
                          gutterBottom
                          color="textPrimary"
                        > How do I generate a free QR code for Apps Download Link?
                        </Typography>


                        <Typography
                          variant="body1"
                          gutterBottom
                          color="textPrimary"
                        >
QR codes have become an essential part of mobile applications, allowing users to quickly access information. Fortunately, there are now free QR code generators available for the App Store, Play Store, and Microsoft Store. These generators make it easy to create custom QR codes for your app with no coding or design experience necessary. With just a few clicks, you can create a unique QR code that will help increase engagement with your app.                           </Typography>

                      </Box>
                    </CardContent>

                  </CardActionArea>
                </Card>

              </Grid>

            </Grid>
          </Box>


        </Container>
      </div>
    </div >
  );
};

FAQs.propTypes = {
  className: PropTypes.string
};

export default FAQs;
